import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCross = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12 4V20",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "square"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20 12L4 12",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "square"
	})]
});
export default SvgCross;
